import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import UserGroupForm from './UserGroupForm';
import FormToolbar from '../shared/FormToolbar';

const UserGroupEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <UserGroupForm {...props} />
    </SimpleForm>
  </Create>
);

export default UserGroupEdit;
